"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var react_2 = require("@headlessui/react");
var storybook_1 = require("@eyecons/storybook");
function NotificationsHead(_a) {
    var setOpen = _a.setOpen;
    return react_1.default.createElement("div", { className: "sm:px-6 sticky inset-x-0 border-b border-gray-400" },
        react_1.default.createElement("div", { className: "flex items-start justify-between p-4" },
            react_1.default.createElement(react_2.Dialog.Title, { className: "text-lg font-medium text-gray-900" }, "Notificaties"),
            react_1.default.createElement("div", { className: "ml-3 h-7 flex items-center" },
                react_1.default.createElement("button", { type: "button", className: "bg-white rounded-md text-black hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:primary right-4 top-4 absolute z-20", onClick: function () { return setOpen(false); } },
                    react_1.default.createElement("span", { className: "sr-only" }, "Close panel"),
                    react_1.default.createElement(storybook_1.Icons.Icon, { name: 'x', className: "h-6 w-6" })))));
}
exports.default = NotificationsHead;
